import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import Button from '@mui/material/Button';
import Tooltip from '@mui/material/Tooltip';
import IconButton from '@mui/material/IconButton';
import Divider from '@mui/material/Divider';
import CloseIcon from '@mui/icons-material/Close';
import ThemeContent from './ThemeContent';
import { bool, func } from 'prop-types';
import usePrefer from '../hooks/usePrefer';
import sty from '../styles/Prefer.module.css';
import { UserMenuHandle } from '../types/enums';

/**
 * @component Preferences
 * @desc Represents the Preferences component, which displays a dialog for user preferences.
 * @param {Object} props
 * @param {object} props.open
 * @param {function} props.onHandleOpen
 * @returns {JSX.Element}
 */
function Preferences({ open, onHandleOpen }) {
	const { state, handler } = usePrefer(onHandleOpen);

	return (
		<Dialog open={open}>
			<DialogTitle className={sty.pf_dialogTitle}>
				User Preferences
				<Tooltip title="Close">
					<IconButton onClick={() => onHandleOpen(UserMenuHandle.ClosePrefer)}>
						<CloseIcon />
					</IconButton>
				</Tooltip>
			</DialogTitle>
			<Divider />
			<DialogContent className={sty.pf_dialogContent}>
				<ThemeContent mode={state.mode} onMode={handler.onMode} />
			</DialogContent>
			<Divider />
			<DialogActions>
				<Button
					className={sty.pf_btn}
					variant="outlined"
					onClick={handler.onSave}
				>
					SAVE
				</Button>
			</DialogActions>
		</Dialog>
	);
}

Preferences.propTypes = { open: bool.isRequired, onHandleOpen: func.isRequired };

export default Preferences;
